module.exports = __webpack_public_path__ + "img/404.89ddb978.svg";